import React, { Component } from 'react';
import moment from 'moment';
import Swipe from 'react-easy-swipe';

import BlastDataManager from '../managers/BlastDataManager';
import LocalDataManager from '../managers/LocalDataManager';
import StackUpService from '../services/StackUpService';
import AccountService from '../services/AccountService';
import GroupsService from '../services/GroupsService';

import StackupTopBar from './Stackup/StackupTopBar';
import StackupViewCentral from './Stackup/StackupViewCentral';
import StackupBottomBar from './Stackup/StackupBottomBar';

export default class StackupPage extends Component {

    constructor(props) {
        super(props);

        window.zzActiveObject = this;

        this.blastDataManager = new BlastDataManager();
        this.dbm = new LocalDataManager();
        this.stackService = new StackUpService();
        this.accountService = new AccountService();
        this.groupsService = new GroupsService();

        this.state = {
            screenContext: {
                mode: 'intro',
                range: 'YTD',
                resetSlider: true,
                tagList: {},
                groupList: {},
                masterKpiList: {},
                locationList: [],
                selectedLocation: {},
                sortBy: 'NAME',
                sortByDir: 'ASC',
                selectKpiMode: false,
                selectedKpiList: window.localStorage.selectedKpiList != undefined ? JSON.parse(window.localStorage.selectedKpiList)
                    : ['Total Sales', 'Service Sales', 'Product Sales', 'Customer Count', 'New Customers', 'Productivity']
            },
            tagFilter: {
                clientAccountId: '',
                tags: [],
                groups: [],
                filterDate: moment().format("MM/DD/YYYY"),
                userTypeId: 5,
                locationIds: []
            },
            stackData: [],
            isScrollTop: true,
            selectedItems: [],
            searchText: '',
            searchTop: 0,
            swipeMode: 0,
            accountInfo: null,
        }

        this.settings = this.dbm.getSettingsInfo();

        this.swipeMode = 0;
        this.swipeX = 0;
        this.swipeY = 0;
        this.scrollTop = 0;
        this.curView = null;

        this.stackupInit = this.stackupInit.bind(this);
        this.updateStackup = this.updateStackup.bind(this);
        this.organizeStackData = this.organizeStackData.bind(this);
        this.organizeTags = this.organizeTags.bind(this);

        this.handleScrollTop = this.handleScrollTop.bind(this);
        this.handleChangeTopSelector = this.handleChangeTopSelector.bind(this);
        this.toggleSelectKpi = this.toggleSelectKpi.bind(this);
        this.toggleKpiListItem = this.toggleKpiListItem.bind(this);
        this.changeSort = this.changeSort.bind(this);
        this.changePeriod = this.changePeriod.bind(this);
        this.changeDate = this.changeDate.bind(this);

        this.saveTags = this.saveTags.bind(this);

        this.onSwipeStart = this.onSwipeStart.bind(this);
        this.onSwipeMove = this.onSwipeMove.bind(this);
        this.onSwipeEnd = this.onSwipeEnd.bind(this);
        this.onSwipeLeft = this.onSwipeLeft.bind(this);
        this.onSwipeRight = this.onSwipeRight.bind(this);
        this.animateSwipe = this.animateSwipe.bind(this);
        this.cutResetSlider = this.cutResetSlider.bind(this);

        this.canSelectPeriod = this.canSelectPeriod.bind(this);

        window.zzResume = () => { };
        window.zzPause = () => { };

        let self = this;
        self.props.superInit(self.stackupInit, undefined, () => { self.updateStackup() }, undefined);
    }

    componentDidMount() {

    }

    componentDidUpdate() {

    }

    componentWillReceiveProps() {

    }

    componentWillUnmount() {

    }

    stackupInit() {

        let self = this;

        this.dbm.getAccountInfo().then((accountInfo) => {
            
            if(accountInfo.isDashboardOnly)
            {
                self.props.changePage('login', false);
                return;
            }
            let locationList = accountInfo.clientAccountList[zzDataCache.settings.selectedClientAccountIndex].locations;
            let screenContext = self.state.screenContext;
            screenContext.locationList = locationList;
            let locationIds = [];
            locationList.forEach((loc) => {
                locationIds.push(loc.locationID);
            })

            let tagFilter = self.state.tagFilter;
            tagFilter.clientAccountId = accountInfo.clientAccountList[zzDataCache.settings.selectedClientAccountIndex].clientAccountId;
            tagFilter.userTypeId = accountInfo.userType;
            tagFilter.locationIds = locationIds;

            self.stackService.masterKpis(mkres => {
                let tmpMkList = {}
                mkres.forEach(mk => {
                    tmpMkList[mk.masterKpiId] = mk;
                });
                screenContext.masterKpiList = tmpMkList;

                self.stackService.tags((tagRes) => {

                    screenContext.tagList = self.organizeTags(tagRes);

                    let tempTagIds = [];
                    for (var i = 0; i < tagRes.length; i++) {
                        tempTagIds.push(tagRes[i].tagId);
                    }

                    tagFilter.tags = [];

                    try {
                        let userId = JSON.parse(window.localStorage['zzAccount']).userId;
                        this.stackService.getUserTagsAndGroups(userId, (userStackupSettings) => {

                            let tmporaryTagFilter = [];
                            let tmporaryGroupFilter = [];

                            if (userStackupSettings.tagItems !== undefined && userStackupSettings.tagItems !== null) {
                                for (var i = 0; i < userStackupSettings.tagItems.length; i++) {
                                    tmporaryTagFilter.push(userStackupSettings.tagItems[i].tagId);
                                }
                            }

                            tagFilter.tags = tmporaryTagFilter;

                            if (userStackupSettings.groupItems !== undefined && userStackupSettings.groupItems !== null) {
                                for (var i = 0; i < userStackupSettings.groupItems.length; i++) {
                                    tmporaryGroupFilter.push(userStackupSettings.groupItems[i].groupId);
                                }
                            }


                            tagFilter.groups = tmporaryGroupFilter;

                            self.setState({ tagFilter: tagFilter });
                        }, (er) => {
                            console.log(er);
                        });
                    }
                    catch (err) {
                        console.log(err);
                    }

                    self.groupsService.getGroupsForStackup({
                        clientAccountId: accountInfo.clientAccountList[zzDataCache.settings.selectedClientAccountIndex].clientAccountId,
                        userId: accountInfo.userId
                    }, (groups) => {

                        let tmpGroupMap = {};
                        groups.forEach(g => {
                            let gkey = g.groupId;
                            if (!tmpGroupMap[gkey]) {
                                tmpGroupMap[gkey] = {
                                    groupId: g.groupId,
                                    name: g.name,
                                    description: g.description
                                }
                            }
                        });

                        screenContext.groupList = tmpGroupMap;
                        tagFilter.groups = [];


                        self.stackService.stackup(tagFilter, (stackRes) => {

                            let organizedStackData = self.organizeStackData(stackRes, locationList);

                            let tmpActiveLocs = [];
                            for (var i = 0; i < locationList.length; i++) {
                                if (Object.keys(organizedStackData[locationList[i].name]).length > 0) {
                                    tmpActiveLocs.push(locationList[i]);
                                }
                            }
                            screenContext.locationList = tmpActiveLocs;

                            self.setState({ screenContext: screenContext, accountInfo: accountInfo, tagFilter: tagFilter, stackData: organizedStackData }, () => {
                                self.props.loadingOff();
                                setTimeout(() => {
                                    screenContext.mode = 'locs';
                                    self.setState({ screenContext: screenContext });
                                }, 250);
                            });
                        }, (err) => {
                            self.props.loadingOff();

                            alert("An error occurred. Please try again later.");
                            self.props.changePage('leaderboard', false);
                        });

                    }, (err) => {
                        self.props.loadingOff();

                    });

                }, (err) => {
                    self.props.loadingOff();

                });
            }, err => {
                self.props.loadingOff();
            });
        }, (err) => {
            self.props.loadingOff();
        });
    }

    updateStackup() {
        let self = this;
        self.props.loadingOn();

        let locationList = self.state.accountInfo.clientAccountList[zzDataCache.settings.selectedClientAccountIndex].locations;
        let tagFilter = self.state.tagFilter;
        let screenContext = this.state.screenContext;

        self.stackService.stackup(tagFilter, (stackRes) => {

            let organizedStackData = self.organizeStackData(stackRes, locationList);

            let tmpActiveLocs = [];
            for (var i = 0; i < locationList.length; i++) {
                if (Object.keys(organizedStackData[locationList[i].name]).length > 0) {
                    tmpActiveLocs.push(locationList[i]);
                }
            }
            screenContext.locationList = tmpActiveLocs;

            self.setState({ stackData: organizedStackData, screenContext: screenContext }, () => {
                self.props.loadingOff();
            });
        }, (err) => {
            self.props.loadingOff();

        });

    }

    organizeStackData(rawData, locationList) {
        let organizedData = {};

        let locationMap = {};
        for (var i = 0; i < locationList.length; i++) {
            locationMap[locationList[i].locationID] = locationList[i].name;
            organizedData[locationList[i].name] = {};
        }

        for (var i = 0; i < rawData.length; i++) {

            try {
                if (!organizedData[locationMap[rawData[i].locationId]][rawData[i].kpiDesc]) {
                    organizedData[locationMap[rawData[i].locationId]][rawData[i].kpiDesc] = {};
                }

                if (!organizedData[locationMap[rawData[i].locationId]][rawData[i].kpiDesc][rawData[i].timeRange]) {
                    organizedData[locationMap[rawData[i].locationId]][rawData[i].kpiDesc][rawData[i].timeRange] = {};
                }

                organizedData[locationMap[rawData[i].locationId]][rawData[i].kpiDesc][rawData[i].timeRange] = rawData[i];
            } catch (e) {

            }
        }

        return organizedData;
    }

    organizeTags(rawData) {

        let organizedData = {};

        for (var i = 0; i < rawData.length; i++) {

            if (!organizedData[rawData[i].category]) {
                organizedData[rawData[i].category] = []
            }

            organizedData[rawData[i].category].push(rawData[i]);
        }

        let categories = Object.keys(organizedData);
        for (var i = 0; i < categories.length; i++) {
            organizedData[categories[i]] = _.sortBy(organizedData[categories[i]], 'name');
        }

        return organizedData;
    }

    handleScrollTop(isScrollTop, scrollTop) {
        if (this.state.isScrollTop != isScrollTop) {
            this.scrollTop = scrollTop;
            this.setState({ isScrollTop: isScrollTop });
        }
    }

    handleChangeTopSelector(value, index, event) {

        let screenContext = this.state.screenContext;

        if (screenContext.mode != 'main') {
            screenContext.mode = 'main';
        }

        if (index != undefined && this.state.screenContext.locationList[index] != undefined && this.state.screenContext.locationList[index].name === value) {
            screenContext.selectedLocation = screenContext.locationList[index];
            this.setState({ screenContext: screenContext });
        } else {
            for (var i = 0; i < this.state.screenContext.locationList.length; i++) {
                if (this.state.screenContext.locationList[i].name === value) {
                    screenContext.selectedLocation = screenContext.locationList[i];
                    this.setState({ screenContext: screenContext });
                    break;
                }
            }
        }
    }

    toggleSelectKpi() {
        let screenContext = this.state.screenContext;
        screenContext.selectKpiMode = !screenContext.selectKpiMode;

        this.setState({ screenContext: screenContext });
    }

    toggleKpiListItem(identity) {
        let screenContext = this.state.screenContext;

        let match = false;
        for (var i = 0; i < screenContext.selectedKpiList.length; i++) {
            if (screenContext.selectedKpiList[i] === identity.kpiDesc) {
                match = true;
                screenContext.selectedKpiList.splice(i, 1);
                break;
            }
        }
        if (!match) {
            screenContext.selectedKpiList.push(identity.kpiDesc);
        }

        window.localStorage.setItem('selectedKpiList', JSON.stringify(screenContext.selectedKpiList));

        this.setState({ screenContext: screenContext });
    }

    changeSort(sortBy, sortByDir) {
        let screenContext = this.state.screenContext;
        screenContext.sortBy = sortBy;
        screenContext.sortByDir = sortByDir;

        this.setState({ screenContext: screenContext });
    }

    changePeriod(range) {

        let screenContext = this.state.screenContext;
        screenContext.range = range;

        this.setState({ screenContext: screenContext });
    }

    changeDate(dateString, dateObject, event) {
        this.props.loadingOn();

        let tagFilter = this.state.tagFilter;
        tagFilter.filterDate = moment(dateObject).format("MM/DD/YYYY");

        let self = this;
        this.setState({ tagFilter: tagFilter }, () => {
            self.updateStackup();
        });
    }

    saveTags(tags, groups) {
        let tagFilter = this.state.tagFilter;

        let tempTags = [];
        for (var i = 0; i < tags.length; i++) {
            tempTags.push(tags[i].tagId);
        }

        tagFilter.tags = tempTags;

        tagFilter.groups = groups.map(x => x.groupId);

        let self = this;
        try {

            let stackupUserTagsAndGroups = {
                userId: JSON.parse(window.localStorage['zzAccount']).userId,
                tags: tagFilter.tags,
                groups: tagFilter.groups
            };

            self.stackService.saveUserTagsAndGroups(stackupUserTagsAndGroups, () => { console.log('Success saving tags!') }, () => { 'Failure to save tags!' });

        }
        catch (err) {
            console.log(err);
        }

        this.setState({ tagFilter: tagFilter }, () => {
            self.updateStackup();
        });
    }

    onSwipeStart(event) {

    }

    onSwipeMove(position, event) {

        this.swipeX = position.x;
        this.swipeY = position.y;
    }

    onSwipeEnd(event) {

        let x = this.swipeX;
        let y = this.swipeY;
        this.swipeX = 0;
        this.swipeY = 0;

        if (this.state.swipeMode === 0) {

            if (Math.abs(x) >= Math.abs(y) * 3 && Math.abs(x) > 100 && Math.abs(y) < 100) {
                if (x < 0) {
                    this.onSwipeLeft();
                } else {
                    this.onSwipeRight();
                }
            }
        }
    }

    onSwipeLeft(event) {
        let index = null;
        let prevIndex = null;

        let locationList = this.state.screenContext.locationList;
        let selectedLocation = this.state.screenContext.selectedLocation;

        for (var i = 0; i < locationList.length; i++) {
            if (locationList[i].name === selectedLocation.name) {
                prevIndex = i;
                index = i;
            }
        }

        if (index === null || locationList.length <= 1) {
            // Don't swipe
            return;
        } else if (index === locationList.length - 1) {
            index = 0;
        } else {
            index++;
        }

        this.animateSwipe(prevIndex, index, -1);
    }

    onSwipeRight(event) {
        let index = null;
        let prevIndex = null;

        let locationList = this.state.screenContext.locationList;
        let selectedLocation = this.state.screenContext.selectedLocation;

        for (var i = 0; i < locationList.length; i++) {
            if (locationList[i].name === selectedLocation.name) {
                prevIndex = i;
                index = i;
            }
        }

        if (index === null || locationList.length <= 1) {
            // Don't swipe
            return;
        } else if (index === 0) {
            index = locationList.length - 1;
        } else {
            index--;
        }

        this.animateSwipe(prevIndex, index, 1);
    }

    animateSwipe(prevIndex, index, dir) {
        var self = this;

        let screenContext = this.state.screenContext;
        screenContext.selectedLocation = screenContext.locationList[index];
        screenContext.resetSlider = true;

        this.swipeMode = dir;
        this.setState({
            screenContext: screenContext
        }, () => {
            self.curView.viewOuter.classList.remove('metrics-central-swiping-animation1');
            self.curView.viewOuter.classList.remove('metrics-central-swiping-animation-1');
            void self.curView.viewOuter.offsetWidth;
            self.curView.viewOuter.classList.add('metrics-central-swiping-animation' + dir);
            self.swipeMode = 0;
        });
    }

    cutResetSlider() {
        let screenContext = this.state.screenContext;
        screenContext.resetSlider = false;
        this.setState({ screenContext: screenContext });
    }

    canSelectPeriod(range) {

        let accountInfo = this.state.accountInfo;
        if (accountInfo != undefined && accountInfo != null) {

            let checkRange = range === 'CUR' ? 'NOW' : range;

            for (var i = 0; i < accountInfo.mobileLocationPeriods.length; i++) {
                if (checkRange === accountInfo.mobileLocationPeriods[i]) {
                    return true;
                }
            }
            return false;

        } else {
            return false;
        }
    }


    render() {

        let outerClass = "stackup-page-outer";
        if (this.state.screenContext.mode === 'intro') {
            outerClass += ' stackup-page-outer-intro';
        } else if (this.state.screenContext.mode === 'locs') {
            outerClass += ' stackup-page-outer-locs';
        } else if (this.state.screenContext.mode === 'main') {
            outerClass += ' stackup-page-outer-main';
        }

        return (
            <div id="page-outer" className={outerClass}>
                <StackupTopBar
                    selectedItems={this.state.selectedItems}
                    isScrollTop={this.state.isScrollTop}
                    toggleNav={this.props.toggleNav}
                    updateBlastFilter={this.updateBlastData}
                    clearSelectedItems={this.clearSelectedItems}
                    changeTopSelector={this.handleChangeTopSelector}
                    screenContext={this.state.screenContext}
                />
                <Swipe
                    style={{ width: '100%', height: '100%' }}
                    onSwipeStart={this.onSwipeStart}
                    onSwipeMove={this.onSwipeMove}
                    onSwipeEnd={this.onSwipeEnd}
                >
                    <StackupViewCentral
                        ref={(curView) => { this.curView = curView }}
                        isScrollTop={this.state.isScrollTop}
                        handleScrollTop={this.handleScrollTop}
                        screenContext={this.state.screenContext}
                        stackData={this.state.stackData}
                        changeTopSelector={this.handleChangeTopSelector}
                        changeSort={this.changeSort}
                        toggleSelectKpi={this.toggleSelectKpi}
                        toggleKpiListItem={this.toggleKpiListItem}
                        tagFilter={this.state.tagFilter}
                        cutResetSlider={this.cutResetSlider}
                    />
                </Swipe>
                <StackupBottomBar
                    changeDate={this.changeDate}
                    selectedItems={this.state.selectedItems}
                    screenContext={this.state.screenContext}
                    changePeriod={this.changePeriod}
                    saveTags={this.saveTags}
                    canSelectPeriod={this.canSelectPeriod}
                />
            </div>
        );
    }
}
